import React, { useMemo, useState } from "react";
import { MoneyExAds, MoneyExLimit } from "../../../pages";
import { MoneyExController } from "../../../controllers";

const MoneyExLimitContainer = () => {
  const [viewMoreAdsModal, setViewMoreAdsModal] = useState(false);
  const [createLimitModal, setCreateLimitModal] = useState(false);
  const [updateLimitModal, setUpdateLimitModal] = useState(false);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const moneyExLimtTableQuery = useMemo(() => {
    const query = `offset=${currentPage + 1}&limit=${limit}`;
    return query;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = MoneyExController.useGetMoneyExLimit(
    moneyExLimtTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const closeModal = () => {
    setCreateLimitModal(false);
    setUpdateLimitModal(false);
  };
  const goToCreateLimit = () => {
    setCreateLimitModal(true);
  };
  const goToUpdateLimit = () => {
    setUpdateLimitModal(true);
  };

  return (
    <MoneyExLimit
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      viewMoreAdsModal={viewMoreAdsModal}
      setViewMoreAdsModal={setViewMoreAdsModal}
      closeModal={closeModal}
      createLimitModal={createLimitModal}
      updateLimitModal={updateLimitModal}
      goToCreateLimit={goToCreateLimit}
      goToUpdateLimit={goToUpdateLimit}
    />
  );
};

export default MoneyExLimitContainer;
